import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useStore } from "@/context/StoreContext";

const rise = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, amount: 0.15 },
  transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] },
};

export default function Story() {
  const { t, scrollToSection } = useStore();

  const categories = [
    { key: "cat.knee", sub: "cat.kneeSub", img: "/products/knee-support-pink.png", scroll: true },
    { key: "cat.carry", sub: "cat.carrySub", img: "/products/waist-bag-pink.png", scroll: true },
    { key: "cat.set", sub: "cat.setSub", img: "/products/parent-set.png", scroll: true },
    { key: "cat.soon", sub: "cat.soonSub", img: "/products/coming-soon.png" },
  ];

  return (
    <section className="section section-white" id="story" data-testid="story-section">
      <div className="container">
        <motion.div className="story" {...rise}>
          <div className="story-photo" />
          <div className="story-copy">
            <p className="section-title-small">{t("story.eyebrow")}</p>
            <h2>
              {t("story.title1")}
              <br />
              {t("story.title2")}
              <br />
              {t("story.title3").split("*").map((part, i) => (i % 2 ? <span key={i}>{part}</span> : part))}
            </h2>
            <p className="muted">{t("story.desc")}</p>
            <button className="btn btn-light" data-testid="story-our-story-button">
              {t("story.btn")} →
            </button>
          </div>
          <div className="story-collage">
            <div className="story-small one" />
            <div className="story-small two" />
          </div>
        </motion.div>

        <motion.div className="category-grid" {...rise}>
          {categories.map((c, i) => (
            <button
              key={c.key}
              className={`category-card ${c.key === "cat.set" ? "has-bg" : c.key === "cat.soon" ? "has-bg-soon" : ""}`}
              data-testid={`category-card-${i}`}
              onClick={() => c.scroll && scrollToSection("products")}
            >
              <h3>{t(c.key)}</h3>
              <p>{t(c.sub)}</p>
              <span className="category-arrow"><ArrowRight size={16} /></span>
              {c.img && c.key === "cat.soon" && <img src={c.img} alt="" loading="lazy" className="category-bg-soon" />}
              {c.img && c.key !== "cat.soon" && <img src={c.img} alt="" loading="lazy" className={c.key === "cat.set" ? "category-bg" : ""} />}
            </button>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
